import React, { useState } from 'react';

import '../../../libs/bulma.min.css';
import './PingIp.css';

import { sendPingAndTracertSystem } from '../../../services';

function CommandPage() {
  const [command, setCommand] = useState('ping');
  const [ip, setIp] = useState('8.8.8.8');
  const [log, setLog] = useState('');
  const [isRunning, setIsRunning] = useState(false);

  const startCommand = async () => {
    setLog('');
    setIsRunning(true);

    try {
      const response = await sendPingAndTracertSystem({ ip, command });
      
      if (!response.body) {
        throw new Error('Seu navegador não suporta streaming.');
      }
      
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let done = false;

      while (!done) {
        const { value, done: doneReading } = await reader.read();
        done = doneReading;
        if (value) {
          setLog((prev) => prev + decoder.decode(value));
        }
      }
    } catch (error) {
      setLog(`Erro: ${error.message}`);
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <div className="ping-container">      
      <div className="ping-header">
        <div className="ping-title-wrapper">
          <svg className="ping-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
          </svg>
          <div>
            <h1 className="ping-title">Conectividade VigosCloud</h1>
            <p className="ping-subtitle">Teste de ping e traceroute</p>
          </div>
        </div>
      </div>
      
      <div className="ping-content">
        <div className="ping-form-card">
          <div className="ping-form-row">
            <div className="ping-form-field">
              <label className="ping-form-label">Comando</label>
              <div className="ping-form-control">
                <select
                  className="ping-form-select"
                  value={command}
                  onChange={(e) => setCommand(e.target.value)}
                >
                  <option value="ping">Ping</option>
                  <option value="traceroute">Traceroute</option>
                </select>
              </div>
            </div>
            <div className="ping-form-field">
              <label className="ping-form-label">IP ou Domínio</label>
              <div className="ping-form-control">
                <input
                  className="ping-form-input"
                  type="text"
                  value={ip}
                  onChange={(e) => setIp(e.target.value)}
                  placeholder="Digite o IP ou domínio..."
                />
              </div>
            </div>
          </div>
          <div className="ping-form-actions">
            <button
              className={`btn-execute ${isRunning ? 'is-loading' : ''}`}
              onClick={startCommand}
              disabled={isRunning}
            >
              {isRunning ? (
                <>
                  <div className="spinner"></div>
                  <span>Executando...</span>
                </>
              ) : (
                <>
                  <svg className="btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>Executar Comando</span>
                </>
              )}
            </button>
          </div>
        </div>
        
        <div className="ping-log-card">
          <div className="ping-log-header">
            <svg className="ping-log-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span className="ping-log-title">Resultado do Comando</span>
          </div>
          <div className="ping-log-content">
            {log || 'Aguardando execução...'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommandPage;
